import { render, staticRenderFns } from "./anchor-recommend.vue?vue&type=template&id=23371a09&scoped=true"
import script from "./anchor-recommend.vue?vue&type=script&lang=js"
export * from "./anchor-recommend.vue?vue&type=script&lang=js"
import style0 from "./anchor-recommend.vue?vue&type=style&index=0&id=23371a09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23371a09",
  null
  
)

export default component.exports